var map = {
	"./ebanisteria.png": 6978,
	"./ebanisteriaOri.png": 3420,
	"./electricos.png": 2579,
	"./electricosOri.png": 6401,
	"./estudiantil.png": 5172,
	"./estudiantilOri.png": 2680,
	"./gas.png": 6539,
	"./gasOri.png": 5873,
	"./griferia.png": 1541,
	"./griferiaOri.png": 8468,
	"./logoCatalogo.png": 7409,
	"./logoCatalogoOri.png": 7090,
	"./tornilleria.png": 3538,
	"./tornilleriaOri.png": 4881
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2013;